import PropTypes from 'prop-types';
import React from 'react';
import UIkit from 'uikit';
import { questions } from '../utilities/questions';
import { onlyUnique, parameterize } from '../utilities/methods';
import produce from 'immer';

export default class Filter extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      started: false,
      selections: [],
      isReverse: false,
      visibleProducts: props.product_families.length,
      totalProducts: props.product_families.length,
      products: props.products
    }
    this.renderOption = this.renderOption.bind(this);
    this.pushSelection = this.pushSelection.bind(this);
    this.getSelectionForQuestion = this.getSelectionForQuestion.bind(this);
  }

  componentDidMount() {
    // HACK: Rather than rebuilding the active class functionality, using UIkit.filter for
    // style and click styling interactings. Filtering is done by filterProducts function, NOT UIKIT
    UIkit.filter('#react-filter', { target: '#react-filter-target'} )
    this.filterProducts();
  }

  setProductsCount = () => {
    this.setState({
      visibleProducts: $('.js-product-family-name:visible').length,
      totalProducts: $('.js-product-family-name').length
    })
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.selections.length != this.state.selections.length) {
      this.filterProducts();
      this.setProductsCount();
    }
    if (prevState.isReverse == this.state.isReverse && prevState.selections.length != this.state.selections.length) {
      this.setState({ isReverse: prevState.selections.length > this.state.selections.length })
    }
    UIkit.update();
  }

  filterProducts() {

    if (this.state.selections.length) {
      $("[data-filter-categories]").addClass('uk-hidden');
      let filteredSelector = this.state.selections.map((selection) => {
        return "[data-filter-categories*=" + selection.value + "]"
      }).join("")
      $(filteredSelector).removeClass('uk-hidden');
    } else {
      $("[data-filter-categories]").removeClass('uk-hidden');
    }


    $('.js-product-family-name').each((i, el) => {
      var $el = $(el);
      var visibleProducts = $el.find('[data-filter-categories]:not(.uk-hidden)');
      var allProducts = $el.find('[data-filter-categories]');
      $el.find('.js-product-count').html('Showing ' + visibleProducts.length + ' of ' + allProducts.length + ' product variants');
      if (visibleProducts.length != 0) {
        $el.removeClass('uk-hidden');
      } else {
        $el.addClass('uk-hidden');
      }
      $el.find('.js-toggle-show').on('click', (e) => {
        e.preventDefault();
        $(e.currentTarget).addClass('uk-hidden');
        $(e.currentTarget).next().removeClass('uk-hidden');
        $el.find('.js-product-count').html('Showing ' + $el.find('[data-filter-categories]:not(.uk-hidden)').length + ' of ' + $el.find('[data-filter-categories]').length + ' product variants')
        visibleProducts.removeClass('uk-hidden');
      });
      $el.find('.js-toggle-filter').on('click', (e) => {
        e.preventDefault();
        $(e.currentTarget).addClass('uk-hidden');
        $(e.currentTarget).prev().removeClass('uk-hidden');
        this.filterProducts();
      });
    });
    $('.js-product-type-grouping').each((i, el) => {
      var $el = $(el);
      var visibleProducts = $el.find('[data-filter-categories]:not(.uk-hidden)');
      if (visibleProducts.length != 0) {
        $el.removeClass('uk-hidden');
      } else {
        $el.addClass('uk-hidden');
      }
    });
  }

  answeredQuestions () {
    return (
      questions.filter((question) => {
        return this.getSelectionForQuestion(question)
      })
    )
  }

  validUnansweredQuestions () {
    // TODO: check to see if there are unfiltered options
    // TODO: make the values an option array with special case
    return (
      questions.filter((question) => {
        var options = this.getUniqueOptionsForProductField(question.id);
        if (question.id == "dry_contact__c" && options.length < 2) {
          return false
        }
        return !this.getSelectionForQuestion(question) && options.length
      })
    )
  }

  render() {
    return (
      <div className="uk-margin-medium-bottom">
        <div className="uk-padding-small uk-background-muted uk-position-relative">
          <div className={ "uk-margin-small-left " + (!this.validUnansweredQuestions().length || !this.state.started ? "uk-position-center-left" : "uk-position-top-left uk-margin-small-top") }>
            <p className="uk-text-italic uk-text-small uk-margin-remove"><em>{ "Showing " + this.state.visibleProducts + " of " + this.state.totalProducts + " products" } </em></p>
          </div>
          { this.renderStart() }
          { this.renderFinished() }
          <div className={ "uk-margin-small-right " + (!this.validUnansweredQuestions().length || !this.state.started ? "uk-position-center-right" : "uk-position-bottom-right uk-margin-small-bottom") }>
            { this.renderControls() }
          </div>
        </div>
        { this.renderAnswers() }
      </div>
    );
  }
  renderStart() {
    if (this.state.started) {
      return (
        <div>
          { this.answeredQuestions().concat( this.validUnansweredQuestions()[0] || [])
              .map(this.renderQuestion) }
        </div>
      )
    } else {
      return (
        <h4 className="uk-text-center uk-margin-remove uk-animation-fade">Find the product you are looking for</h4>
      )
    }
  }

  getUniqueOptionsForProductField (field) {
   return (
     this.state.products.reduce((field_values, product) => {
       if(product[field] != null) {
         product[field].split(";").forEach((tag) => {
          field_values.push(tag)
         })
       }
       return field_values
     }, []).filter(onlyUnique).filter(Boolean)
   )
  }

  renderControls() {
    if (this.state.started) {
      return (
        <div className="uk-flex">
          { this.renderBack() }
          <a onClick={ this.clearSelections } className="pla-button-icon-link pla-button-icon-link-small uk-flex uk-flex-middle" >
            <i className="icomoon-x-circle brand-blue uk-margin-remove-left"></i>
            <span>Clear all</span>
          </a>
        </div>
      )
    } else {
      return (
        <a onClick={ () => this.setState({ started: true } )} className="pla-button-icon-link pla-button-icon-link-small uk-flex uk-flex-middle" >
          <i className="icomoon-filter uk-margin-remove-left"></i>
          <span>Get started</span>
        </a>
      )
    }

  }

  renderBack() {
    if (this.state.selections.length) {
      return (
        <a onClick={ this.popSelection } className="uk-margin-right pla-button-icon-link pla-button-icon-link-small uk-flex uk-flex-middle" >
          <i className="icomoon-chevron-left uk-margin-remove-left"></i>
          <span>Back</span>
        </a>
      )
    }
  }

  renderAnswers() {
    if (this.state.selections.length) {
      return (
        <div className={ "uk-margin " + (this.state.isReverse ? "uk-animation-slide-left-small  " : "uk-animation-slide-right-medium ") }>
          { this.state.selections.map(selection => <span key={ selection.questionId } className="uk-badge uk-margin-small-right uk-text-uppercase">{ selection.title }</span> ) }
        </div>
      )
    }
  }

  renderFinished() {
    if (!this.validUnansweredQuestions().length ) {
      return (
        <h4 className="uk-text-center uk-margin-remove uk-animation-fade">See your product results below.</h4>
      )
    }
  }

  getSelectionForQuestion = (question) => {
    return this.state.selections.find( (selection) => selection.questionId == question.id )
  }

  renderQuestion = (question) =>  {
    return(
      <div className={ "uk-margin-medium-top  " + (this.state.isReverse ? "uk-animation-slide-left-small  " : "uk-animation-slide-right-medium ") + (this.getSelectionForQuestion(question) ? "uk-hidden" : "") } key={ question.id }>
        <div className="uk-flex uk-flex-middle">
          <h3 className="uk-margin-remove">{ question.title }</h3>
          { this.renderInformation(question) }
        </div>
        <ul className="uk-subnav uk-subnav-pill subnav-pill-large uk-margin-remove-left">
          {this.getUniqueOptionsForProductField(question.id).map(this.renderOption(question)) }
        </ul>
      </div>
    )
  }

  renderInformation (question) {
    if (question.id == "pollutant_load_factor__c") {
      return (
        <div className="uk-margin-small-left uk-margin-5-top">
          <a className="" uk-toggle="target: #load-factor"><i className="icomoon-info"></i></a>
        </div>
      )
    }
  }


  renderOption = (question) => {
    return  (option, index) => {
      return (
        <li key={ index } uk-filter-control={ "filter: [data-filter-categories*=" + parameterize(option) + "];" + "group: " + question.id + ";" }>
          <a onClick={ this.pushSelection(question, option) }>{option}</a>
        </li>
      )
    }
  }


  popSelection = () => {
    this.setState(
      // probably don't need immer, but I like it and it may be necessary as complexity increases
      produce(draft => {
        var { selections } = draft
        selections.pop()
        draft.selections = selections
      })
    )
    this.filterProductsBySelection()
  }

  clearSelections = () => {
    this.setState(
      produce(draft => {
        var { selections } = draft
        selections = []
        draft.started = false
        draft.isReverse = false
        draft.selections = selections
      })
    )
  }

  pushSelection = (question, option) => {
    return () => {
      this.setState(
        //😇 glad I added immer
        produce(draft => {
          var { selections } = draft
          selections.push({ questionId: question.id, value: parameterize(option), title: option })
          draft.selections = selections
        })
      )
      this.filterProductsBySelection()
    }
  }

  filterProductsBySelection = () => {
    this.setState(
      produce(draft => {
        var products = this.props.products
        if (draft.selections.length) {
          products = products.filter( (product) => {
            return draft.selections.every((selection) => {
              return product.tags.indexOf(selection.value) !== -1
            })
          });
        }
        draft.products = products
      })
    )
  }
}
